import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import EcoLink from 'eco-design/base/eco-link';
import Arrow from './icons/Arrow';
import IndexClient from './index.client';
import './index.scss';

export default function Content({ id, data = {} }: ContentServerProps) {
    const prefixCls = 'index-user-endorsement';
    const { title, desc, more_btn_href, more_btn_text, bgColor, list, cardDescFontSize } = data;

    const MoreLink: React.FC<{ cls: string }> = ({ cls }) => (
        <>
            {more_btn_href && more_btn_text && (
                <EcoLink className={`${prefixCls}-link ${cls}`} href={more_btn_href}>
                    <span>{more_btn_text}</span>
                    <Arrow />
                </EcoLink>
            )}
        </>
    );

    return (
        <GloLayout
            className={`editor-${prefixCls}`}
            id={id}
            data={data}
            floorName={prefixCls}
            style={
                {
                    backgroundColor: bgColor,
                    color: ['#000000', 'black'].includes(bgColor) ? '#fff' : '#000',
                    '--item-desc-size-pc': cardDescFontSize === 'big' ? '20px' : cardDescFontSize === 'small' ? '14px' : '16px',
                    '--item-desc-size-h5': cardDescFontSize === 'big' ? '14px' : cardDescFontSize === 'small' ? '10px' : '12px',
                } as React.CSSProperties
            }
        >
            <div className={`${prefixCls}-wrapper`}>
                {(title || desc || (more_btn_href && more_btn_text)) && (
                    <div className={`${prefixCls}-head`}>
                        {(title || desc) && (
                            <div className={`${prefixCls}-info`}>
                                {title && <h2 className={`${prefixCls}-title`}>{title}</h2>}
                                {desc && <p className={`${prefixCls}-desc`}>{desc}</p>}
                            </div>
                        )}
                        <MoreLink cls="pc" />
                    </div>
                )}
                <IndexClient id={id} prefixCls={prefixCls} list={list} bgColor={bgColor} />
                <MoreLink cls="h5" />
            </div>
        </GloLayout>
    );
}
